// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__2F4s5","wrapper":"styles_wrapper__q1Zao","label":"styles_label__hahp7"};